export default __webpack_public_path__ + "static/media/logorositaputih.02e6427f.png";